import { DeleteAccount } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _GoogleConsoleService {
  public deleteAccount(deleteAccount: DeleteAccount) {
    return HttpService.post("/user/api/v1/google-console/delete-user", {
      body: { ...deleteAccount },
    });
  }
}

const GoogleConsoleService = new _GoogleConsoleService();

export default GoogleConsoleService;
